import { FC, useCallback } from "react";
import { Button, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import EmptyCommitmentsImage from "../../../../assets/empty-states/empty-commitments.png";
import { useAppSelector } from "../../../../store/hooks";
import { biggestOrgSelector } from "../../../../store/accounts/selectors/all-providers/biggestOrgSelector";
import { generateLiveResourcesPath } from "../../accounts-group/utils/helpers/generateLiveResourcesPath";

export const EmptyCommitments: FC = () => {
  const navigate = useNavigate();
  const biggestOrg = useAppSelector(biggestOrgSelector);

  const onClickHandler = useCallback(() => {
    if (!biggestOrg) {
      return;
    }

    navigate(
      generateLiveResourcesPath({
        provider: biggestOrg.provider,
        orgId: biggestOrg.orgId,
      }),
    );
  }, [navigate, biggestOrg]);

  return (
    <Stack alignItems="center" gap={4} pt={22}>
      <img src={EmptyCommitmentsImage} alt="EmptyCommitments" />

      <Typography variant="h6" fontWeight="bold">
        We currently support commitments for AWS and Azure.
      </Typography>

      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={onClickHandler}
      >
        Go to Live Resources
      </Button>
    </Stack>
  );
};
